module.exports = __webpack_public_path__ + "static/media/instagram.345f7e26.svg";